import { render } from "./editOrganization.vue?vue&type=template&id=51514713&scoped=true"
import script from "./editOrganization.vue?vue&type=script&lang=js"
export * from "./editOrganization.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./editOrganization.vue?vue&type=style&index=1&id=51514713&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51514713"]])

export default __exports__